<template>
  <div>
    <div>
      <p class="font-bold text-center text-lg">
        NOTICE TO {{ memberList.join(" ").toUpperCase() }}
      </p>
      <p class="font-bold text-center text-lg">
        TREATMENT OF CERTAIN PAYMENTS FROM THE FUND
      </p>
    </div>
    <!-- eslint-disable max-len -->
    <div class="px-0 py-8">
      <p class="mt-4">
        This notice is to confirm that certain payments from the Fund during the
        {{ finYear }} financial year will be treated in accordance with your request
        summarised in the attached schedule to the extent permitted by legislation.
      </p>
      <p class="mt-4">
        You can change these instructions at any time.
      </p>
      <div style="break-inside: avoid;">
        <p class="mt-8">
          Yours faithfully,
        </p>
        <div class="px-0 mt-16">
          <table class="table-auto w-full">
            <tbody>
              <tr class="w-full">
                <td class="w-2/12 py-2">
                  __________________________________
                </td>
                <td class="py-2">
                  __________________________________
                </td>
              </tr>

              <tr class="w-full">
                <td class="w-2/12 py-2">
                  {{ trusteeType === 'individual' ? 'Trustee' : 'Director' }}
                </td>
                <td class="mt-16 text-left w-2/12">Date</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pensionInstructionMixin } from '@/app/mixins/toolkit/pension-instructions/instruction';
import { percent } from '@/app/filters/filters';

export default {
  name: 'notice',
  mixins: [pensionInstructionMixin],
  computed: {
    memberList() {
      return this.members.flatMap((member, idx) => (idx > 0 ? `and ${member.name}` : member.name));
    },
    rules() {
      const { rules } = this.getItem;
      return rules;
    },
  },
  methods: {
    isComputedRule(rule) {
      return (typeof rule !== 'string');
    },
    processRule(rule) {
      if (this.isComputedRule(rule)) {
        return this.processedPDF(rule);
      }
      return rule;
    },
    accounts(rule) {
      const output = [];

      rule.accounts.ruleAccounts.forEach((account) => {
        let row = '';
        if (rule.extra.type === 'percentage') {
          row = `<span class="font-bold">${account.value}%</span> - `;
        }
        row += `${account.member.name} / ${account.label} / ${account.identifier} / ${percent(account.taxFree)} tax free`;
        output.push(row);
      });
      return output;
    },
  },
};

</script>
